<template>
  <QuadroPrincipal v-if="!!complemento.length" :titulo="nome ? `Complemento de ${nome}`.toUpperCase() : ''" :classe="classe">
    <RegistrosComplemento 
      :classe="classe"
      :complemento="complemento"
      :seleciona="seleciona"
      :complementoSelecionado="complementoSelecionado"
      :selecionouComplemento="selecionouComplemento"
      :edita="edita"
      :loading="loading"
    />

    <CalculoComplemento :cargaEfetivaTributaria="cargaEfetivaTributaria" />
  </QuadroPrincipal>
</template>

<script>
import CalculoComplemento from '@/components/CalculoComplemento/CalculoComplemento.vue'
import QuadroPrincipal from '@/components/QuadroPrincipal/QuadroPrincipal.vue'
import RegistrosComplemento from '@/components/RegistrosComplemento/RegistrosComplemento.vue'

export default {
  name: 'QuadroComplementoIcms',

  props: {
    classe: String,
    nome: String,
    complemento: Object | Array,
    seleciona: Function,  
    loading: Boolean,
    complementoSelecionado: Object,
    selecionouComplemento: Boolean,
    edita: Function,
    cargaEfetivaTributaria: Number,
  },

  components: {
    CalculoComplemento,
    QuadroPrincipal,
    RegistrosComplemento,
  },

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>